import { render, staticRenderFns } from "./dollars-campus.vue?vue&type=template&id=64b323b2&scoped=true"
import script from "./dollars-campus.vue?vue&type=script&lang=js"
export * from "./dollars-campus.vue?vue&type=script&lang=js"
import style0 from "./dollars-campus.vue?vue&type=style&index=0&id=64b323b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b323b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b323b2')) {
      api.createRecord('64b323b2', component.options)
    } else {
      api.reload('64b323b2', component.options)
    }
    module.hot.accept("./dollars-campus.vue?vue&type=template&id=64b323b2&scoped=true", function () {
      api.rerender('64b323b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dollars/dollars-campus.vue"
export default component.exports